<template>
  <ContentPage>
    <template #header>
      <Progress :step="2" :steps="5">
        <h2 class="py-1" style="line-height: 28px;">
          Please Verify Your Business Information
        </h2>
        <div class="my-2 mx-8" style="font-size: 14px">
          This information will not be shared with anyone outside the app.
        </div>
      </Progress>
    </template>

    <v-form ref="form">
      <v-container class="rounded-lg white">
        <v-row>
          <v-col cols="12" class="pt-6 pb-0">
            <v-text-field v-model="business_name"
              outlined dense persistent-placeholder
              :rules="[required]"
              label="Business Name"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field v-model="contact_name"
              outlined dense persistent-placeholder
              :rules="[required]"
              label="Contact Name"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field v-model="email"
              outlined dense persistent-placeholder
              label="Email"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field v-model="phone"
              outlined dense persistent-placeholder
              label="Phone"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="backClick">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import Progress from './progress'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: "WizardStepB",

  components: { ContentPage, Progress },

  data() {
    return {
      business_name: '',
      contact_name: '',
      email: '',
      phone: '',

      error_dialog: false,
      error_message: '',

      // validation rules
      required,
    }
  },

  computed: {
    ...mapGetters('auth', ['me']),
  },

  watch: {
    me(newMe) {
      this.setMe(newMe)
    }
  },

  methods: {
    ...mapActions('auth', ['loadMe', 'updateMe']),

    backClick() {
      this.$router.replace( { name: 'wizard' } )
    },

    async nextClick() {
      if (this.$refs.form.validate()) {
        const payload = {
          business_name: this.business_name,
          contact_name: this.contact_name,
          email: this.email,
          phone: this.phone,
        }

        const result = await this.updateMe(payload)
        if (result.ok) {
          this.$router.replace( { name: 'wizardC' } )
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },

    setMe(newMe) {
      this.business_name = newMe.business_name
      this.contact_name = newMe.contact_name
      this.email = newMe.email
      this.phone = newMe.phone
    },
  },

  created() {
    this.setMe(this.me)
    this.loadMe();
  }
}
</script>
